var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fature-palte"},[_c('div',{staticClass:"header",staticStyle:{"height":"40px","background":"#ccc"}},[_c('el-row',[_c('el-col',{attrs:{"span":3}}),_c('el-col',{attrs:{"span":3}}),_c('el-col',{attrs:{"span":5}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }